import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { HelpersService } from '../../helpers.service'
import { IntegrationsService } from '../integrations.service'

@Injectable({
  providedIn: 'root'
})
export class OdooService {
  private builderUrl = ''
  odooConnected = false
  projectId = this.builderService.selectedProject
  jsonOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json')
  }
  urlOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }

  constructor(private integrationsService: IntegrationsService, private http: HttpClient, private helpers: HelpersService, private builderService: BuilderService) {
    this.builderUrl = this.helpers.getBuilderUrl()
    this.integrationsService.getIntegrations().subscribe((response) => {
      this.odooConnected = response.odooConnected
    })
  }

  /**
   * 1️⃣ Connect to Odoo (authenticate + verify credentials)
   */
  connect(data: any): Observable<any> {
    const payload = {
      ...data,
      projectId: this.projectId
    }

    const params = new URLSearchParams()
    params.set('data', JSON.stringify(payload))

    const url = `${this.builderUrl}odoo-connect?${params.toString()}`
    return this.http.get(url, this.urlOptions)
  }

  // ======================================================
  // 2️⃣ GET TOTAL PRODUCTS COUNT
  // ======================================================
  getOdooProductsCount(): Observable<any> {
    const url = `${this.builderUrl}odoo-products-count`
    return this.http.post(url, { projectId: this.projectId }, this.jsonOptions)
  }

  // ======================================================
  // 3️⃣ SYNC ALL PRODUCTS (BATCHED)
  // ======================================================
  syncAllProducts(): Observable<any> {
    return new Observable((observer) => {
      this.getOdooProductsCount().subscribe(
        (res: any) => {
          const total = res.data?.total || 0
          this.syncProductBatch(0, total, observer)
        },
        (error) => observer.error(error)
      )
    })
  }

  private syncProductBatch(offset: number, total: number, observer: any): void {
    if (offset >= total) {
      observer.next({ done: true, total })
      observer.complete()
      return
    }

    const url = `${this.builderUrl}odoo-sync-products`

    this.http
      .post(
        url,
        {
          projectId: this.projectId,
          offset
        },
        this.jsonOptions
      )
      .subscribe(
        (res: any) => {
          const data = res.data || res

          observer.next({
            done: false,
            offset: data.offset,
            synced: data.synced,
            total
          })

          // 🔁 Fetch next batch
          this.syncProductBatch(data.offset, total, observer)
        },
        (error) => observer.error(error)
      )
  }

  /**
   * 3️⃣ Fetch Odoo Categories
   */
  syncAllCategoriesOdoo(): Observable<any> {
    const payload = { projectId: this.projectId }
    const url = `${this.builderUrl}odoo-sync-categories`

    return this.http.post(url, payload, this.jsonOptions)
  }
}
